var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "infoRegForm" }, [
    _c("div", { staticClass: "info" }, [
      _c(
        "div",
        { staticClass: "info-box" },
        [
          _c("div", { staticClass: "title-box" }, [
            _vm._v("重庆医科大学高等学历继续教育学生入学信息登记表"),
          ]),
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.formData, rules: _vm.rules } },
            [
              _c("div", { staticClass: "info-floor" }, [
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c("span", { staticClass: "name" }, [_vm._v("学号:")]),
                    _c("el-input", {
                      staticClass: "input",
                      attrs: { readonly: "", placeholder: "" },
                      model: {
                        value: _vm.userInfo.student_code,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "student_code", $$v)
                        },
                        expression: "userInfo.student_code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c("span", { staticClass: "name" }, [_vm._v("年级:")]),
                    _c("el-input", {
                      staticClass: "input",
                      attrs: { readonly: "", placeholder: "" },
                      model: {
                        value: _vm.userInfo.grade,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "grade", $$v)
                        },
                        expression: "userInfo.grade",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c("span", { staticClass: "name" }, [_vm._v("学习形式:")]),
                    _c("el-input", {
                      staticClass: "input",
                      attrs: { readonly: "", placeholder: "" },
                      model: {
                        value: _vm.userInfo.study_form_title,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "study_form_title", $$v)
                        },
                        expression: "userInfo.study_form_title",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info-floor" }, [
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c("span", { staticClass: "name" }, [_vm._v("专业:")]),
                    _c("el-input", {
                      staticClass: "input",
                      attrs: { readonly: "", placeholder: "" },
                      model: {
                        value: _vm.userInfo.profession_title,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "profession_title", $$v)
                        },
                        expression: "userInfo.profession_title",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "table-box" }, [
                _c("table", { staticClass: "table-item" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "cell table-name",
                          attrs: { rowspan: "8" },
                        },
                        [
                          _c("p", [_vm._v("学")]),
                          _c("p", [_vm._v("生")]),
                          _c("p", [_vm._v("本")]),
                          _c("p", [_vm._v("人")]),
                          _c("p", [_vm._v("基")]),
                          _c("p", [_vm._v("本")]),
                          _c("p", [_vm._v("情")]),
                          _c("p", [_vm._v("况")]),
                        ]
                      ),
                      _c("td", { staticClass: "cell name" }, [_vm._v("姓名")]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [_vm._v(_vm._s(_vm.userInfo.student_title))]
                      ),
                      _c("td", { staticClass: "cell name" }, [_vm._v("性别")]),
                      _c("td", { staticClass: "cell" }, [
                        _vm._v(_vm._s(_vm.userInfo.sex_title)),
                      ]),
                      _c("td", { staticClass: "cell name" }, [_vm._v("民族")]),
                      _c("td", { staticClass: "cell" }, [
                        _vm._v(_vm._s(_vm.userInfo.nation)),
                      ]),
                      _c(
                        "td",
                        {
                          staticClass: "cell avatar",
                          staticStyle: { width: "200px" },
                          attrs: { rowspan: "5" },
                        },
                        [
                          _vm.userInfo.admission_img
                            ? _c("el-image", {
                                attrs: {
                                  src: _vm.userInfo.admission_img,
                                  fit: "cover",
                                },
                              })
                            : _c("div", [
                                _c("p", [_vm._v("贴")]),
                                _c("p", [_vm._v("正")]),
                                _c("p", [_vm._v("面")]),
                                _c("p", [_vm._v("头")]),
                                _c("p", [_vm._v("像")]),
                              ]),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "cell required" }, [
                        _vm._v("政治面貌"),
                      ]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "political_status" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择政治面貌",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.formData.political_status,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "political_status",
                                        $$v
                                      )
                                    },
                                    expression: "formData.political_status",
                                  },
                                },
                                _vm._l(_vm.outlookList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.title,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("td", { staticClass: "cell" }, [_vm._v("学制")]),
                      _c("td", { staticClass: "cell" }, [
                        _vm._v(_vm._s(_vm.userInfo.education_length)),
                      ]),
                      _c("td", {
                        staticClass: "cell",
                        attrs: { colspan: "2" },
                      }),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "cell" }, [_vm._v("出生日期")]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [_vm._v(_vm._s(_vm.userInfo.birth_date))]
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [_vm._v("入学形式")]
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "admission_form" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.admission_form,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "admission_form",
                                        $$v
                                      )
                                    },
                                    expression: "formData.admission_form",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("成人高考"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("其他"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "cell" }, [_vm._v("学历层次")]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [_vm._v(_vm._s(_vm.userInfo.education_level_title))]
                      ),
                      _c("td", { staticClass: "cell" }, [_vm._v("身份证号")]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "7" } },
                        [_vm._v(_vm._s(_vm.userInfo.id_card))]
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "cell required" }, [
                        _vm._v("入学前最高学历"),
                      ]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "pre_education" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.pre_education,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "pre_education", $$v)
                                  },
                                  expression: "formData.pre_education",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "cell required",
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("入学前毕业学校及专业")]
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "3" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "",
                                prop: "pre_school_profession",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.pre_school_profession,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "pre_school_profession",
                                      $$v
                                    )
                                  },
                                  expression: "formData.pre_school_profession",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { rowspan: "2" } },
                        [_vm._v("工作信息")]
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "4" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "参加工作时间:",
                                "label-width": "120px",
                                prop: "work_start_date",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.formData.work_start_date,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "work_start_date",
                                      $$v
                                    )
                                  },
                                  expression: "formData.work_start_date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "3" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "现工作单位:",
                                "label-width": "100px",
                                prop: "current_work_unit",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.current_work_unit,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "current_work_unit",
                                      $$v
                                    )
                                  },
                                  expression: "formData.current_work_unit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "4" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "单位电话:",
                                "label-width": "100px",
                                prop: "unit_phone",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.unit_phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "unit_phone", $$v)
                                  },
                                  expression: "formData.unit_phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "职务:",
                                    "label-width": "80px",
                                    prop: "position",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { clearable: "", placeholder: "" },
                                    model: {
                                      value: _vm.formData.position,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "position", $$v)
                                      },
                                      expression: "formData.position",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "职称:",
                                    "label-width": "80px",
                                    prop: "job_title",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { clearable: "", placeholder: "" },
                                    model: {
                                      value: _vm.formData.job_title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "job_title", $$v)
                                      },
                                      expression: "formData.job_title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "td",
                        { staticClass: "cell" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "邮编:",
                                "label-width": "80px",
                                prop: "postal_code",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.postal_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "postal_code", $$v)
                                  },
                                  expression: "formData.postal_code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "cell table-name",
                          attrs: { rowspan: "3" },
                        },
                        [
                          _c("p", [_vm._v("通")]),
                          _c("p", [_vm._v("讯")]),
                          _c("p", [_vm._v("录")]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "cell name required",
                          staticStyle: { width: "100px" },
                          attrs: { rowspan: "2" },
                        },
                        [_vm._v("详细通讯地址")]
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "cell",
                          attrs: { rowspan: "2", colspan: "5" },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "detailed_address" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.detailed_address,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "detailed_address",
                                      $$v
                                    )
                                  },
                                  expression: "formData.detailed_address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("td", { staticClass: "cell name" }, [
                        _vm._v("邮政编码"),
                      ]),
                      _c(
                        "td",
                        { staticClass: "cell" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "", prop: "address_postal_code" },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.address_postal_code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "address_postal_code",
                                      $$v
                                    )
                                  },
                                  expression: "formData.address_postal_code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "cell name required" }, [
                        _vm._v("电子邮箱"),
                      ]),
                      _c(
                        "td",
                        { staticClass: "cell" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "email", $$v)
                                  },
                                  expression: "formData.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "cell name" }, [
                        _vm._v("手机号"),
                      ]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [_vm._v(" " + _vm._s(_vm.userInfo.mobile_phone) + " ")]
                      ),
                      _c("td", { staticClass: "cell name" }, [_vm._v("座机")]),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "2" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "landline" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.landline,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "landline", $$v)
                                  },
                                  expression: "formData.landline",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("td", { staticClass: "cell name required" }, [
                        _vm._v("QQ号"),
                      ]),
                      _c(
                        "td",
                        { staticClass: "cell" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "qq_number" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.qq_number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "qq_number", $$v)
                                  },
                                  expression: "formData.qq_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "cell table-name",
                            attrs: {
                              rowspan: _vm.formData.personal_resume.length + 1,
                            },
                          },
                          [
                            _c("p", [_vm._v("个")]),
                            _c("p", [_vm._v("人")]),
                            _c("p", [_vm._v("主")]),
                            _c("p", [_vm._v("要")]),
                            _c("p", [_vm._v("简")]),
                            _c("p", [_vm._v("历")]),
                          ]
                        ),
                        _c(
                          "td",
                          { staticClass: "cell name", attrs: { colspan: "3" } },
                          [_vm._v("何年何月-何年何月")]
                        ),
                        _c(
                          "td",
                          { staticClass: "cell name", attrs: { colspan: "3" } },
                          [_vm._v("在何地工作或学习")]
                        ),
                        _c("td", { staticClass: "cell name" }, [
                          _vm._v("任职情况"),
                        ]),
                        _c("td", { staticClass: "cell name" }, [
                          _vm._v("备注"),
                        ]),
                      ]),
                      _vm._l(
                        _vm.formData.personal_resume,
                        function (item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "cell", attrs: { colspan: "3" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.time,
                                        callback: function ($$v) {
                                          _vm.$set(item, "time", $$v)
                                        },
                                        expression: "item.time",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell", attrs: { colspan: "3" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.cont,
                                        callback: function ($$v) {
                                          _vm.$set(item, "cont", $$v)
                                        },
                                        expression: "item.cont",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.situation,
                                        callback: function ($$v) {
                                          _vm.$set(item, "situation", $$v)
                                        },
                                        expression: "item.situation",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.remark,
                                        callback: function ($$v) {
                                          _vm.$set(item, "remark", $$v)
                                        },
                                        expression: "item.remark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tbody",
                    [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "cell table-name",
                            attrs: {
                              rowspan: _vm.formData.family_members.length + 1,
                            },
                          },
                          [
                            _c("p", [_vm._v("家")]),
                            _c("p", [_vm._v("庭")]),
                            _c("p", [_vm._v("成")]),
                            _c("p", [_vm._v("员")]),
                            _c("p", [_vm._v("情")]),
                            _c("p", [_vm._v("况")]),
                          ]
                        ),
                        _c("td", { staticClass: "cell name" }, [
                          _vm._v("姓名"),
                        ]),
                        _c("td", { staticClass: "cell name" }, [
                          _vm._v("年龄"),
                        ]),
                        _c("td", { staticClass: "cell name" }, [
                          _vm._v("关系"),
                        ]),
                        _c(
                          "td",
                          { staticClass: "cell name", attrs: { colspan: "4" } },
                          [_vm._v("工作单位")]
                        ),
                        _c("td", { staticClass: "cell name" }, [
                          _vm._v("联系电话"),
                        ]),
                      ]),
                      _vm._l(
                        _vm.formData.family_members,
                        function (item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "cell" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.name,
                                        callback: function ($$v) {
                                          _vm.$set(item, "name", $$v)
                                        },
                                        expression: "item.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.age,
                                        callback: function ($$v) {
                                          _vm.$set(item, "age", $$v)
                                        },
                                        expression: "item.age",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        readonly: "",
                                        clearable: "",
                                        placeholder: "",
                                      },
                                      model: {
                                        value: item.relationship,
                                        callback: function ($$v) {
                                          _vm.$set(item, "relationship", $$v)
                                        },
                                        expression: "item.relationship",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell", attrs: { colspan: "4" } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.employer,
                                        callback: function ($$v) {
                                          _vm.$set(item, "employer", $$v)
                                        },
                                        expression: "item.employer",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              { staticClass: "cell" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "" } },
                                  [
                                    _c("el-input", {
                                      attrs: { clearable: "", placeholder: "" },
                                      model: {
                                        value: item.phone,
                                        callback: function ($$v) {
                                          _vm.$set(item, "phone", $$v)
                                        },
                                        expression: "item.phone",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "9" } },
                        [
                          _c("div", [
                            _vm._v(
                              "本人知晓此表为高等学历继续教育学籍档案的重要组成部分，并郑重承诺：实事求是填写有关内容，对内容的真实性有效性负责。"
                            ),
                          ]),
                          _c("div", { staticClass: "esign-info-box" }, [
                            _c(
                              "div",
                              { staticClass: "esign-box" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "学生签名：",
                                      "label-width": "120px",
                                      prop: "sign_img",
                                    },
                                  },
                                  [
                                    _c("esignHandle", {
                                      ref: "esignHandle",
                                      attrs: {
                                        selectSignImg: _vm.formData.sign_img,
                                      },
                                      on: {
                                        "update:selectSignImg": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "sign_img",
                                            $event
                                          )
                                        },
                                        "update:select-sign-img": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "sign_img",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "10px",
                                  "text-align": "right",
                                },
                              },
                              [
                                _c("span", [_vm._v("填表时间:")]),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "10px" } },
                                  [_vm._v(_vm._s(_vm.formData.fill_date))]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        { staticClass: "cell name", attrs: { colspan: "2" } },
                        [_vm._v("备 注")]
                      ),
                      _c(
                        "td",
                        { staticClass: "cell", attrs: { colspan: "5" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "remarks" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "" },
                                model: {
                                  value: _vm.formData.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "remarks", $$v)
                                  },
                                  expression: "formData.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "cell",
                          staticStyle: { width: "282px", height: "80px" },
                          attrs: { colspan: "2" },
                        },
                        [
                          _c("p", { staticClass: "chapter" }, [
                            _vm._v(
                              "重庆医科大学继续教育学院(教务与学生管理科)盖章"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      "text-align": "center",
                      "padding-right": "50px",
                    },
                  },
                  [_vm._v("重庆医科大学继续教育学院制")]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btn-box" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmClick } },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            {
              staticClass: "exit-btn",
              attrs: { type: "primary" },
              on: { click: _vm.exit },
            },
            [_vm._v("退出登录")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }